import React, { Component } from 'react';
import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import SpinnerComponent from '../../../components/SpinnerComponent';
import EditRecordButton from '../components/EditRecordButton';
import NewRecordButton from '../components/NewRecordButton';
import TablePageToolbar from '../components/TablePageToolbar';
import BasicTable from '../../../components/BasicTable.js';
import {
  getCountGruppi,
  getCountGruppiFiltered,
  getGruppi,
} from '../../../utils/api/gruppi_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = {
  root: {
    textAlign: 'center',
    color: 'black',
    paddingTop: '30px',
    minHeight: '100%',
  },
};

export default class GruppiTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gruppi: [],
      loading: true,
      totalPages: 10,
      loadedPage: 0,
      pageSize: 10,
      id: '',
      nome: '',
    };
  }

  componentDidMount() {
    this.fetchGruppi(0);
  }

  fetchGruppi = (loadedPage) => {
    getCountGruppi()
      .then((countResult) => {
        getGruppi(
          this.state.id,
          this.state.nome,
          loadedPage,
          this.state.pageSize,
          'id',
        )
          .then((result) => {
            this.setState({
              gruppi: result,
              totalPages: Math.ceil(countResult / this.state.pageSize),
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
            reportApiError(error);
          });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchGruppiForPageChange = (loadedPage) => {
    getGruppi(
      this.state.id,
      this.state.nome,
      loadedPage,
      this.state.pageSize,
      'id',
    )
      .then((result) => {
        this.setState({
          gruppi: result,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchGruppiForResearch = () => {
    getCountGruppiFiltered(this.state.id, this.state.nome)
      .then((resultCount) => {
        return getGruppi(this.state.id, this.state.nome, 0, 10, 'id').then(
          (result) => {
            this.setState({
              gruppi: result,
              totalPages:
                resultCount > 0
                  ? Math.ceil(resultCount / this.state.pageSize)
                  : 1,
              loading: false,
            });
          },
        );
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  onPageChange = (pageIndex) => {
    this.setState(
      {
        loadedPage: pageIndex,
      },
      () => this.fetchGruppiForPageChange(this.state.loadedPage),
    );
  };

  render() {
    const columns = [
      {
        Header: 'Numero',
        id: 'numero',
        accessor: (row) => row,
        width: 120,
        filterable: false,
        // 0-based, as every other table in the panel numbers its rows. The
        // concatenation reads correctly only while pageSize stays 10 and the
        // index stays one digit: at another pageSize this needs arithmetic.
        Cell: (props) =>
          this.state.loadedPage === 0
            ? '' + props.index
            : this.state.loadedPage + '' + props.index,
      },
      {
        Header: 'ID gruppo',
        id: 'id',
        accessor: (d) => d.id,
        filterable: true,
        width: 180,
        Filter: (
          <TextField
            fullWidth
            variant="outlined"
            inputProps={{ 'aria-label': 'Cerca per ID' }}
            value={this.state.id}
            onChange={(e) => {
              let inputValue = e.target.value;
              let regex = /^[0-9]+$/;

              if (regex.test(inputValue) || inputValue === '') {
                this.setState({
                  id: inputValue,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    aria-label="Cerca per ID"
                    onClick={() => {
                      this.setState(
                        {
                          loadedPage: 0,
                        },
                        () => {
                          if (this.state.id === '' && this.state.nome === '') {
                            this.fetchGruppi(0);
                          } else {
                            this.fetchGruppiForResearch();
                          }
                        },
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Nome',
        id: 'nome',
        accessor: (d) => d.nome,
        filterable: true,
        minWidth: 120,
        Filter: (
          <TextField
            variant="outlined"
            fullWidth
            inputProps={{ 'aria-label': 'Cerca per Nome' }}
            value={this.state.nome}
            onChange={(e) => {
              this.setState({
                nome: e.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    aria-label="Cerca per Nome"
                    onClick={() => {
                      this.setState(
                        {
                          loadedPage: 0,
                        },
                        () => {
                          if (this.state.id === '' && this.state.nome === '') {
                            this.fetchGruppi(0);
                          } else {
                            this.fetchGruppiForResearch();
                          }
                        },
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Brand',
        id: 'brand',
        accessor: (d) => (d.brand === null ? ' - ' : d.brand.nome),
        minWidth: 90,
        filterable: false,
      },
      {
        Header: 'Modifica',
        id: 'modifica',
        width: 120,
        filterable: false,
        accessor: (row) => {
          return <EditRecordButton recordId={row.id} disabled={false} />;
        },
      },
    ];
    return (
      <div style={styles.root}>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <div>
            <TablePageToolbar
              actions={
                <NewRecordButton
                  disabled={this.state.loading}
                  label="Crea nuovo gruppo"
                />
              }
            />
            <BasicTable
              columns={columns}
              data={this.state.gruppi}
              loading={this.state.loading}
              filterable={false}
              resizable={true}
              sortable={false}
              defaultPageSize={this.state.pageSize}
              page={this.state.loadedPage}
              pages={this.state.totalPages}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
      </div>
    );
  }
}
